import { Col, Drawer, Radio, Row, Typography, Modal, Grid } from 'antd'
import React, { useContext, useEffect, useRef, useState } from 'react'
import withMobile from '../../utils/isMobile'
import { StepContext } from '../../utils/StepContext'
import CheckList from '../CheckList'
import { ReactComponent as PZIcon } from '../../assets/svg/ProtezioneZR.svg'

const { useBreakpoint } = Grid

const PZModalContent = () => (
  <Row gutter={[24, 16]}>
    <ul style={{ listStyle: 'revert', marginLeft: 12 }}>
      <Col>
        <li>Non perdi nemmeno una mensilità, ti paghiamo puntualmente il 12 del mese anche in caso di mora o ritardo</li>
      </Col>
      <Col>
        <li>Compiliamo un'analisi del merito creditizio di ogni inquilino che vuole affitare casa tua</li>
      </Col>
      <Col>
        <li>Non ti lasciamo solo: in caso di sfratto dell'inquilino, hai assistenza legale totalmente gratuita</li>
      </Col>
      <Col>
        <li>Hai personale dedicato a te e ai tuoi immobili nella gestione delle visite e di tutta la burocrazia</li>
      </Col>
    </ul>
  </Row>
)

const Contratto = (props) => {
  const { feePercentage, firstMonthFeePercentage, withInsuranceFeePercentage, with_insurance } = props.formValue
  const { xs } = useBreakpoint()
  const { isBack } = useContext(StepContext)
  const [modalOpen, setModalOpen] = useState(false)
  const [propertyWithInsurance] = useState(with_insurance)
  const [expanded, setExpanded] = useState(false)
  const [enabled, setEnabled] = useState(true)
  const toggleModal = () => {
    setModalOpen(!modalOpen)
  }
  const toggleExpanded = () => {
    setExpanded(!expanded)
  }
  useEffect(() => {
    props.addValue({ with_insurance: enabled })
    props.form.setFieldsValue({ with_insurance: enabled })
  }, [enabled])
  useEffect(() => {
    if (isBack || props.isEditing) {
      setEnabled(propertyWithInsurance)
    } else {
      setEnabled(true)
    }
  }, [])
  return (
    <>
      <Typography.Title level={2}>Leggi ed accetta le condizioni ed i termini del servizio</Typography.Title>
      <Row gutter={{
        xxl: 64,
        xl: 52,
        lg: 48,
        sm: 24,
        xs: 12
      }}>
        <Col xl={10} lg={12} md={24} xs={24} sm={24} style={{
          paddingTop: 14,
          paddingBottom: 14
        }}>
          <Row gutter={{
            xxl: 64,
            xl: 52,
            lg: 48,
            sm: 14,
            xs: 6
          }}>
            <Col xs={3} sm={2} md={24}>
              <div style={{
                width: 32
              }}>
                <PZIcon width='100%' height={64} />
              </div>
            </Col>
            <Col xs={20} md={24} style={{
              display: 'flex',
              alignItems: 'center'
            }}>
              <Typography.Title level={4} style={{ margin: 0 }}>Protezione ZappyRent</Typography.Title>
            </Col>
          </Row>
          {/* <div style={{
            width: xs ? '10%' : '10%',
            display: xs ? 'inline-block' : 'block'
          }}>
            <PZIcon width='100%' height={64} />
          </div> */}
          {/* <Typography.Title level={4}>Protezione ZappyRent</Typography.Title> */}
          <Typography.Paragraph>{`Il costo del servizio ZappyRent è del ${firstMonthFeePercentage}% il primo mese e dell'${feePercentage + (propertyWithInsurance ? 0 : withInsuranceFeePercentage)}% i mesi successivi`}</Typography.Paragraph>
          {xs ? (
            <Typography.Paragraph style={{ color: '#D2007E', textDecoration: 'underline', cursor: 'pointer' }} onClick={toggleModal}>Cos'è protezione ZappyRent?</Typography.Paragraph>
          ) : (
            <Typography.Paragraph style={{ color: '#D2007E' }}>Cos'è protezione ZappyRent?</Typography.Paragraph>
          )}
          {!xs && (
            <>
              <Typography.Paragraph strong ellipsis={{
                rows: expanded ? 20 : 5,
                expandable: false                
              }}>
                Non perdi nemmeno una mensilità, ti paghiamo puntualmente il 12 del mese anche in caso di mora o ritardo. Compiliamo un'analisi del merito creditizio di ogni inquilino che vuole affitare casa tua. Non ti lasciamo solo: in caso di sfratto dell'inquilino, hai assistenza legale totalmente gratuita. Hai un team dedicato a te e ai tuoi immobili nella gestione delle visite e di tutta la burocrazia.
              </Typography.Paragraph>
              {!expanded && <Typography.Link style={{ color: '#D2007E', textDecoration: 'underline' }} onClick={toggleExpanded}>Continua a leggere..</Typography.Link>}
            </>
          )}
        </Col>
        <Col xl={10} lg={12} md={24} xs={24} sm={24} style={{
          background: '#FBFBFB',
          paddingTop: 14,
          paddingBottom: 14,
          borderRadius: 14
        }}>
          <Typography.Title level={5}>Le garanzie di Protezione ZappyRent</Typography.Title>
          <CheckList
            options={[
              "Ricevi l'affitto anche se l'inquilino smette di pagare",
              "Analizziamo il merito creditizio dei possibili inquilini",
              "Eventuale sfratto a carico nostro",
              "Registriamo noi il contratto"
            ]}
          />
        </Col>
      </Row>
      <Modal
        title="Cos' è protezione ZappyRent?"
        visible={!props.isMobile && modalOpen}
        onCancel={toggleModal}
        onOk={toggleModal}
        centered
        footer={null}
      >
        <PZModalContent />
      </Modal>
      <Drawer
        title="Cos' è protezione ZappyRent?"
        placement='bottom'
        height='80vh'
        closable
        onClose={toggleModal}
        visible={props.isMobile && modalOpen}
      >
        <PZModalContent />
      </Drawer>
    </>
  )
}

export default withMobile(Contratto)
